export default __webpack_public_path__ + "static/media/rnr-sports-table-18.c44ac7e6.webp";